export default "__VITE_ASSET__CpW2vRcI__"